import { memo } from 'react'
import { TruckIcon } from '@heroicons/react/24/outline'
import { getInputClasses, getSelectClasses, getTextareaClasses, labelClasses, errorMessageClasses } from '../../../../styles/inputStyles'

/**
 * BasicInfoFields - Basic entity information fields
 * Handles name, type, category, status, and description
 */
const BasicInfoFields = memo(function BasicInfoFields({
  formData,
  validationErrors,
  onInputChange
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Name */}
      <div>
        <label htmlFor="name" className={labelClasses}>
          <TruckIcon className="h-4 w-4 inline mr-1" />
          Name *
        </label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={(e) => onInputChange('name', e.target.value)}
          className={getInputClasses(!!validationErrors.name) + ' px-4 py-2'}
          placeholder="Enter entity name"
          required
        />
        {validationErrors.name && (
          <p className={errorMessageClasses}>{validationErrors.name}</p>
        )}
      </div>

      {/* Entity Type */}
      <div>
        <label htmlFor="entityType" className={labelClasses}>
          Type *
        </label>
        <select
          id="entityType"
          value={formData.entityType}
          onChange={(e) => onInputChange('entityType', e.target.value)}
          className={getSelectClasses(!!validationErrors.entityType) + ' px-4 py-2'}
          required
        >
          <option value="">Select type</option>
          <option value="food_truck">Food Truck</option>
          <option value="pop_up">Pop-up</option>
          <option value="food_cart">Food Cart</option>
          <option value="market">Market</option>
          <option value="other">Other</option>
        </select>
        {validationErrors.entityType && (
          <p className={errorMessageClasses}>{validationErrors.entityType}</p>
        )}
      </div>

      {/* Category */}
      <div>
        <label htmlFor="category" className={labelClasses}>
          Category
        </label>
        <input
          type="text"
          id="category"
          value={formData.category}
          onChange={(e) => onInputChange('category', e.target.value)}
          className={getInputClasses(!!validationErrors.category) + ' px-4 py-2'}
          placeholder="e.g., Mexican, Italian, BBQ"
        />
        {validationErrors.category && (
          <p className={errorMessageClasses}>{validationErrors.category}</p>
        )}
      </div>

      {/* Status */}
      <div className="md:col-span-2">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={formData.isActive}
            onChange={(e) => onInputChange('isActive', e.target.checked)}
            className="rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="ml-2 text-sm text-gray-700">Entity is active</span>
        </label>
      </div>

      {/* Description */}
      <div className="md:col-span-2">
        <label htmlFor="description" className={labelClasses}>
          Description
        </label>
        <textarea
          id="description"
          value={formData.description}
          onChange={(e) => onInputChange('description', e.target.value)}
          rows={4}
          className={getTextareaClasses() + ' px-4 py-2'}
          placeholder="Enter entity description"
        />
      </div>
    </div>
  )
})

export default BasicInfoFields
